<template>
    <div v-if="hasFieldToDisplay()">
        <div class="tabulation-title">
            <h5>
                <v-icon class="blue--text text--darken-2">label</v-icon> Dispositions sanitaires
            </h5>
        </div>

        <div class="form-container mr-auto ml-auto mt-3">
            <p>
                Détaillez ci-dessous en quelques phrases les services et prestations mis en place (modalités de
                réservation, nombre de personnes maximal dans un groupe/en terrasse, procédures sanitaires, équipement à
                disposition...).
                Ces informations seront largement diffusées vers vos visiteurs via nos supports de communication.
            </p>

            <v-textarea v-if="hasField('DESC_COVID19')" class="textarea" :value="frenchDescCovid"
                @change="updateDescCovid" label="Dispositions spéciales COVID 19 😷" outlined>
            </v-textarea>

            <v-autocomplete v-if="hasFamilyElement('DispositionsCovid') &&
            (dispositionsCovid.length > 0 || !getField('DispositionsCovid').skipped)"
                            :value="dispositionsCovid" :items="getFamilyByCode('DispositionsCovid')" chips
                @change="updateOrDeleteElement($event, 'dispositionsCovid')" deletable-chips
                label="Dispositions complémentaires" item-text="label" return-object multiple outlined>
            </v-autocomplete>

            <v-autocomplete v-else-if="hasFamilyElement('DispositionsCovid') && dispositionsCovid.length === 0 &&
             getField('DispositionsCovid').skipped"
                            :items="['Non concerné']"
                            chips
                            :value="'Non concerné'"
                            label="Dispositions complémentaires"
                            outlined>
            </v-autocomplete>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from "vuex"

export default {
    name: "Covid",
    data() {
        return {
            dispositionsCovid: []
        }
    },
    methods: {
        ...mapMutations('web_form', [
            'addElement', 'removeElement'
        ]),
        hasFieldToDisplay() {
            return this.hasField('DESC_COVID19') ||
                this.hasFamilyElement('DispositionsCovid')
        },
        updateDescCovid(value) {
            this.provider.contents.forEach(content => {
                if (content.language.code === 'fr') {
                    content.description_theme_covid = value
                }
            })
        },
        updateOrDeleteElement(newElements, property) {
            let currentElements = this[property]

            if (currentElements.length > newElements.length) {  // Cas suppression
                this.removeElement([currentElements, newElements])
            } else { // Cas Ajout
                this.addElement([currentElements, newElements])
            }

            this[property] = newElements
        }
    },
    computed: {
        ...mapState('web_form', ['provider', 'disabled']),
        ...mapGetters('web_form', ['hasField', 'hasFamilyElement', 'getFamilyByCode', 'getElementsByFamilyCode', 'getField']),
        frenchDescCovid() {
            let _content = {}

            this.provider.contents.forEach(content => {
                if (content.language.code === 'fr') {
                    _content = content
                }
            })

            return _content.description_theme_covid
        }
    },
    created() {
        this.dispositionsCovid = this.getElementsByFamilyCode('DispositionsCovid')
    }
}
</script>
